<template>
  <Spin>
    <Icon
      type="load-c"
      :size="size"
      class="spin-icon-load"
    ></Icon>
  </Spin>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    size: {
      type: Number,
      default: 18,
    },
  },
};
</script>

<style scoped lang="less">
@import "../styles/const.less";

.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
</style>



// WEBPACK FOOTER //
// loading.vue?46d764e8